export const selectAllRegions = state => state.address.allRegions
export const selectSingleRegion = state => state.address.singleRegion
export const selectRegionLocalities = state => state.address.regionLocalities
export const selectAllLocalities = state => state.address.allLocalities
export const selectSingleLocality = state => state.address.singleLocality
export const selectMunicipalityDistricts = state => state.address.municipalityDistricts

// Opciones con código MH (lo que se persiste) además del id (para la cascada depto→muni→distrito SV).
export const selectRegionsForCodeSelect = state =>
  state.address.allRegions?.map(region => ({
    value: region.id,
    label: region.name,
    code: region.code,
  })) || []
export const selectMunicipalityDistrictsForSelect = state =>
  state.address.municipalityDistricts?.map(district => ({
    value: district.id,
    label: district.name,
    code: district.code,
  })) || []

export const selectAllRegionsForSelect = state =>
  state.address.allRegions?.map(region => ({
    value: region.id,
    label: region.name,
  }))
export const selectAllLocalitiesForSelect = state =>
  state.address.allLocalities.map(locality => ({
    ...locality,
    value: locality.id,
    label: locality.name,
  }))
export const selectRegionLocalitiesForSelect = state =>
  state.address.regionLocalities.map(locality => ({
    ...locality,
    value: locality.id,
    label: locality.name,
  }))
